<template>
    <!-- eslint-disable max-len -->
    <div class="app-page-title">
        <div class="page-title-wrapper">
            <div class="page-title-heading">
                <div v-if="avatar" class="avatar-icon-wrapper avatar-icon-xl mr-3">
                        <div class="avatar-icon">
                            <img :src="avatar" alt=""></div></div>
                <div v-if="icon" class="page-title-icon">
                    <i :class="icon"/>
                </div>
                <div>
                    <h1 class="mb-0">{{heading}}</h1>
                    <div class="page-title-subheading pt-0">
                        {{subheading}}
                    </div>
                </div>
            </div>
            <div v-if="view == 'bookings'" class="no-shadow rm-border bg-transparent widget-chart text-left card">
                <div class="progress-circle-wrapper">
                    <vue-circle
                        :progress="78"
                        :size="104"
                        :reverse="true"
                        line-cap="round"
                        :fill="fill1"
                        empty-fill="rgba(0, 0, 0, .1)"
                        :animation-start-value="0.0"
                        :start-angle="0"
                        insert-mode="append"
                        :thickness="7"
                        :show-percent="true">
                    </vue-circle>
                </div>
                <div class="widget-chart-content">
                    <div class="widget-subheading">JOUR : 26 bookings</div>
                    <div class="widget-numbers text-success"><span>563,00 €</span></div>
                    <!-- <div class="widget-description text-focus">
                        Increased by
                        <span class="text-warning pl-1">
                                <font-awesome-icon icon="angle-up"/>
                                <span class="pl-1">7.35%</span>
                            </span>
                    </div> -->
                </div>
            </div>
            <div v-if="view == 'bookings'" class="no-shadow rm-border bg-transparent widget-chart text-left card">
                <div class="progress-circle-wrapper">
                    <vue-circle
                        :progress="62"
                        :size="104"
                        :reverse="true"
                        line-cap="round"
                        :fill="fill2"
                        empty-fill="rgba(0, 0, 0, .1)"
                        :animation-start-value="0.0"
                        :start-angle="0"
                        insert-mode="append"
                        :thickness="7"
                        :show-percent="true">
                    </vue-circle>
                </div>
                <div class="widget-chart-content">
                    <div class="widget-subheading">SEM : 123 bookings</div>
                    <div class="widget-numbers text-success"><span>2540,00 €</span></div>
                    <!-- <div class="widget-description text-focus">
                        Increased by
                        <span class="text-warning pl-1">
                                <font-awesome-icon icon="angle-up"/>
                                <span class="pl-1">7.35%</span>
                            </span>
                    </div> -->
                </div>
            </div>
            <div class="page-title-actions">
                <!-- <button type="button" class="_btn-shadow mr-3 btn btn-dark">
                    <font-awesome-icon icon="star"/>
                </button> -->                
                <button v-if="actions.delete && selection.length" @click="clickOnBulkDelete()" type="button" class="_btn-shadow ml-2 btn btn-danger">
                    <font-awesome-icon class="mr-2" icon="trash"/>
                    Bulk Delete
                </button>
                <button v-if="actions.delete && selection.length"  @click="clickOnBulkSoftDelete()"  type="button" class="_btn-shadow ml-2 btn btn-danger">
                    <font-awesome-icon class="mr-2" icon="trash"/>
                    Bulk Soft Delete
                </button>
                <!-- <button type="button" class="_btn-shadow ml-2 btn btn-info">
                    <font-awesome-icon class="mr-2" icon="forward"/>
                    Bulk actions
                </button> -->
                <button v-if="actions.bulk && selection.length" type="button" class="_btn-shadow ml-2 btn btn-info">
                    <font-awesome-icon class="mr-2" icon="edit"/>
                    Bulk edit
                </button>
                <button v-if="actions.edit" type="button" class="_btn-shadow ml-2 btn btn-info">
                    <font-awesome-icon class="mr-2" icon="edit"/>
                    Edit
                </button>
                <!-- <b-dropdown no-flip text="Change status" class="ml-2" variant="info" right>
                    <button type="button" tabindex="0" class="dropdown-item">Active</button>
                    <button type="button" tabindex="0" class="dropdown-item">Inactive</button>
                </b-dropdown> -->
                <button v-if="actions.new" type="button" class="_btn-shadow ml-2 d-inline-flex align-items-center btn btn-success">
                    <font-awesome-icon class="mr-2" icon="plus"/>
                    Create New
                </button>
                <!-- <button type="button" class="_btn-shadow ml-2 btn btn-info">
                    <font-awesome-icon class="mr-2" icon="rocket"/>
                    Actions
                </button> -->
                <slot></slot>
                <b-dropdown v-if="actions.actions" no-flip text="Actions" class="ml-2" variant="secondary" right>
                    <h6 class="dropdown-header">Export</h6>
                    <button type="button" tabindex="0" class="dropdown-item">Export full list</button>
                    <button type="button" tabindex="0" class="dropdown-item">Export selection</button>
                    <div class="dropdown-divider"></div>
                    <h6 class="dropdown-header">Reporting</h6>
                    <button type="button" tabindex="0" class="dropdown-item">Adeps list</button>
                    <button type="button" tabindex="0" class="dropdown-item">Clubs list</button>
                    <div class="dropdown-divider"></div>
                    <button type="button" class="dropdown-item">Print</button>
                </b-dropdown>
                <!-- <button type="button" class="_btn-shadow ml-2 btn btn-secondary">
                    <font-awesome-icon icon="cog"/>
                </button>
                <button type="button" class="_btn-shadow ml-2 btn btn-secondary">
                    <font-awesome-icon icon="question"/>
                </button> -->
            </div>
        </div>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faStar,
  faPlus,
  faTrash,
  faPlay,
  faForward,
  faRocket,
  faQuestion,
  faEdit,
  faAngleUp,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import VueCircle from 'vue2-circle-progress'

library.add(
  faStar,
  faPlus,
  faTrash,
  faPlay,
  faForward,
  faRocket,
  faQuestion,
  faEdit,
  faAngleUp,
);

export default {
    components: {
        'font-awesome-icon': FontAwesomeIcon,
        VueCircle,
    },
    props: {
        icon: String,
        heading: String,
        subheading: String,
        avatar: String,
        actions: Object,
        selection: Array,
        view: String,
    },
    data: () => ({
        fill: {gradient: ["var(--primary)"]},
        fill1: {gradient: ["#2af598", "#009efd"]},
        fill2: {gradient: ["#fccb90", "#d57eeb"]},
    }),
};
</script>

<style>
.app-page-title {
    margin: 0 -30px;
    padding: 15px 30px;
    background-color: rgb(240, 243, 245);
}
.page-title-heading, .page-title-actions {
    flex-grow: 1;
}
.widget-chart {
    flex-grow: 1;
    padding: 0;
    /* display: none; */
    margin-top: -20px;
}
.percent-text {
    font-size: 20px !important;
}
canvas {
    height: 70px !important;
    width: 70px !important;
}
.widget-chart .widget-numbers {
    font-weight: bold;
    font-size: 2rem;
}
.page-title-actions {
    text-align: right;
}
</style>
